import { parsePhoneNumberFromString } from "libphonenumber-js";

export function formatPhone(value: string | undefined): string | undefined {
    if (!value) return undefined;
    const parsed = parsePhoneNumberFromString(value);
    return parsed?.format("E.164") ?? value;
}
